import React, { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
  ko: string;
  eng: string;
}

const Label: React.FC<Props> = ({ eng, ko, ...props }) => (
  <div className="form-label column col-2" {...props}>
    {/* <em>{eng}</em> */}
    <span>{eng}</span>
  </div>
);

export default Label;
